export default __webpack_public_path__ + "static/media/filtersWhite.f9b708e8.svg";